
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delivery",
      function () {
        return require("private-next-pages/delivery.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delivery"])
      });
    }
  